import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { IMG } from "@/lib/images";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Connexion impossible.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-olime-bg">
      <div className="hidden lg:block relative">
        <img src={IMG.vision} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-olime-ink/40" />
      </div>
      <div className="flex items-center justify-center px-8 py-16">
        <div className="w-full max-w-md">
          <Link to="/"><img src={IMG.logoTeal} alt="O'Lime Design" className="h-12 w-auto mb-10" /></Link>
          <h1 className="font-serif text-4xl">Espace administrateur</h1>
          <p className="text-olime-muted mt-2 text-sm">Connectez-vous pour gérer le studio.</p>
          <form onSubmit={onSubmit} data-testid="login-form" className="mt-10 space-y-6">
            <div>
              <label className="eyebrow">Email</label>
              <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="field-line mt-2" placeholder="marie@olimedesign.fr" />
            </div>
            <div>
              <label className="eyebrow">Mot de passe</label>
              <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="field-line mt-2" placeholder="••••••••" />
            </div>
            {error && <p data-testid="login-error" className="text-sm text-red-600">{error}</p>}
            <button type="submit" data-testid="login-submit" disabled={loading} className="btn-ink w-full disabled:opacity-60">
              {loading && <Loader2 size={14} className="animate-spin" />} Se connecter
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
